import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import { DataGridPro, useGridApiRef } from "@mui/x-data-grid-pro";

export default function GCData({
  height = "40vh",
  Row = [],
  Column = [{ id: 1 }],
  onRowClick = () => {},
  apiRef = null,
}) {
  return (
    <div style={{ height: height, width: "100%" }}>
      <DataGridPro
        apiRef={apiRef && apiRef}
        rowHeight={30}
        getRowId={(row) => row.id}
        headerHeight={40}
        getRowClassName={(params) =>
          params.indexRelativeToCurrentPage % 2 === 0
            ? "mui-even-row"
            : "mui-odd-row"
        }
        sx={{
          border: 1,
          borderColor: "primary.light",
        }}
        rows={Row}
        columns={Column}
        onRowDoubleClick={onRowClick}
        // onRowDoubleClick={fDetail_Grid_DoubleClick}
        // hideFooter={Row.length < 100}
        hideFooter={true}
        // components={{
        //   Toolbar: GridToolbar,
        // }}
      />
    </div>
  );
}
